// Bundle de la pantalla de login. Deliberadamente MAS CHICO que vendor.ts:
// _LoginLayout nunca cargo AdminLTE, solo Bootstrap y Font Awesome. Si usara el
// vendor completo heredaria los resets de AdminLTE (tipografia, .btn, .card,
// reglas sobre html/body) y el login se veria distinto.
//
// Aca si se importa bootstrap.min.css, porque no viene AdminLTE que lo traiga.

import './core/jquery-setup';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import 'bootstrap';
